import { observer } from 'mobx-react-lite'
import { CalendarDropdown, Icon } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { useHubspotWorkflowViewContext } from 'pages/hubspotWorkflows/ui/hubspotWorkflowView/context/context'
import styles from './styles.module.scss'

export const HubspotWorkflowStatisticsSearch = observer(() => {
  const { setSearch, search, calendarFilterStore } = useHubspotWorkflowViewContext()

  return (
    <div className={styles.searchWrap}>
      <div className={styles.search}>
        <Icon icon='search' fontSize={20} padding={6} color='var(--content-primary-tertiary)' />
        <TextField
          variant='integrated'
          InputProps={{
            placeholder: 'Search...',
          }}
          onChange={setSearch}
          value={search || ''}
          ariaLabel='StatisticSearch'
        />
      </div>
      <CalendarDropdown store={calendarFilterStore} />
    </div>
  )
})
